import { render, staticRenderFns } from "./venueDetail.vue?vue&type=template&id=36941404&scoped=true&"
import script from "./venueDetail.vue?vue&type=script&lang=js&"
export * from "./venueDetail.vue?vue&type=script&lang=js&"
import style0 from "./venueDetail.vue?vue&type=style&index=0&id=36941404&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36941404",
  null
  
)

export default component.exports